export default __webpack_public_path__ + "static/media/google.d332beab.png";